import React, {useEffect, useState} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {useHistory} from "react-router-dom";
import fmapLogo from '../images/fmap_logo.png';
import {
    CssBaseline,
    Drawer,
    Hidden,
    List,
    ListItem,
    ListItemText,
    Menu as DropDownMnu,
    MenuItem
} from "@material-ui/core";
import {AccountCircle, ArrowDropDownSharp, CloseSharp, Menu} from "@mui/icons-material";
import {removeSession} from "./sessionUtils";
import {useCookies} from "react-cookie";
import {useUserContext} from "../context/UserContext";
import { useMsal } from "@azure/msal-react";
const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  headerColor: {
    backgroundColor: "#ffffff",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#ffffff",
    color: "#000000",
    fontWeight: "bold",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  menuButtonSm: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  closeMenuButton: {
    marginRight: "auto",
    marginLeft: 0,
  },
  imageStyle: {
    [theme.breakpoints.only("xs")]: {
      width: 50,
    },
    [theme.breakpoints.only("md")]: {
      width: 60,
    },
    [theme.breakpoints.only("sm")]: {
      width: 75,
    },
    [theme.breakpoints.only("lg")]: {
      width: 100,
    },
    [theme.breakpoints.only("xl")]: {
      width: 100,
    },
  },
}));
const drawerWidth = 240;

export default function Navbar() {
  const { user, dispatch } = useUserContext();
  const classes = useStyles();
  let history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    setUserRole(user != null ? user.fmapRole : null);
  }, [user]);

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch({ type: "LOGIN_ERROR" });
    instance.logoutRedirect();
  };

  const drawer = (
    <div>
      <h3 style={{ paddingLeft: 6 }}>Hello {user.firstName}!</h3>
      <List>
        {userRole === "FMAP_ADMIN" && (
          <ListItem button key="Admin">
            <ListItemText
              primary="Admin"
              onClick={() => {
                history.push("/fmapConfiguration");
              }}
            />
          </ListItem>
        )}
        {["FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole) && (
          <ListItem button key="Search">
            <ListItemText
              primary="Search"
              onClick={() => {
                history.push("/agentSearch");
              }}
            />
          </ListItem>
        )}
        {(userRole === null ||
          userRole === undefined ||
          ["FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole)) && (
          <ListItem button key="Consumers">
            <ListItemText
              primary="Consumers"
              onClick={() => {
                history.push("/consumers");
              }}
            />
          </ListItem>
        )}
        {/*{(userRole === null || userRole === undefined || ['FMAP_ADMIN'].includes(userRole)) && <ListItem button key="Agents">*/}
        {/*    <ListItemText primary="Agents" onClick={() => {*/}
        {/*        history.push('/agentRegistration')*/}
        {/*    }}/>*/}
        {/*</ListItem>}*/}
        {(userRole === null || userRole === undefined) && (
          <ListItem button key="Login">
            <ListItemText
              primary="Login"
              onClick={() => {
                history.push("/login");
              }}
            />
          </ListItem>
        )}
        {["FMAP_AGENT", "FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole) && (
          <ListItem button key="Login">
            <ListItemText primary="Logout" onClick={handleLogout} />
          </ListItem>
        )}
      </List>
    </div>
  );
  return (
    <div>
      <CssBaseline />
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="menu">
            <img
              src={fmapLogo}
              alt="FMAP  Logo"
              className={classes.imageStyle}
              onClick={() => {
                history.push("/");
              }}
            />
          </IconButton>

          <Typography variant="h6" className={classes.title}>
            Florida Market Assistance Plan
          </Typography>
          {userRole === "FMAP_ADMIN" && (
            <Button
              color="inherit"
              className={classes.menuButtonSm}
              onClick={() => {
                history.push("/fmapConfiguration");
              }}
            >
              Admin
            </Button>
          )}
          {["FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole) && (
            <Button
              color="inherit"
              className={classes.menuButtonSm}
              onClick={() => {
                history.push("/agentSearch");
              }}
            >
              Search
            </Button>
          )}
          {(userRole === null ||
            userRole === undefined ||
            ["FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole)) && (
            <Button
              color="inherit"
              className={classes.menuButtonSm}
              onClick={() => {
                history.push("/consumers");
              }}
            >
              Consumers
            </Button>
          )}
          {/*{(userRole === null || userRole === undefined || ['FMAP_ADMIN'].includes(userRole)) &&*/}
          {/*<Button color="inherit" className={classes.menuButtonSm} onClick={() => {*/}
          {/*    history.push('/agentRegistration')*/}
          {/*}}>Agents</Button>}*/}
          {(userRole === null || userRole === undefined) && (
            <Button
              color="inherit"
              className={classes.menuButtonSm}
              onClick={() => {
                history.push("/login");
              }}
            >
              Login
            </Button>
          )}
          {["FMAP_AGENT", "FMAP_ADMIN", "FMAP_CC_USER"].includes(userRole) && (
            <Typography variant="h5" component="h2">
              <Button
                color="inherit"
                aria-controls="basic-menu"
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                className={classes.menuButtonSm}
                endIcon={<AccountCircle />}
                onClick={handleClick}
              >
                {user.firstName}
              </Button>

              <DropDownMnu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </DropDownMnu>
            </Typography>
          )}
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <Menu />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer}>
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <IconButton
              onClick={handleDrawerToggle}
              className={classes.closeMenuButton}
            >
              <CloseSharp />
            </IconButton>
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css"></Hidden>
      </nav>
    </div>
  );
};
